import { css } from '@mui/material'
import { PropsWithChildren } from 'react'
import { AuthModalContextProvider } from 'components/Auth/AuthModalContext'
import { GroupTopBarBanner } from 'components/Checkout/TopBarBanner'
import { CurrencyProvider } from 'components/Hook/CurrencyContext'
import { TrackingScript } from 'components/TrackingScript'
import { UserActionsProvider } from 'components/User/UserActionsContext'
import { NewFlexContainer } from 'components/common/common.style'
import { LightGroup } from 'domain/models/Group/EntityGroup'
import { unifiedColors } from 'styles/colors'
import { NoiseBackground } from 'styles/rootPages/404.style'
import { themeUtils } from 'styles/theme'
import Footer from './Footer'
import Header from './Header'

import '@algolia/autocomplete-theme-classic'
import { SearchBarProvider } from './Header/SearchBar/SearchBarContext'

interface LayoutProps extends PropsWithChildren {
  group?: LightGroup | null
  rounded?: boolean
}

export default function Layout({
  children,
  group,
  rounded = true
}: LayoutProps) {
  const allCurrencies = ['EUR', 'CAD', 'CHF']

  return (
    <UserActionsProvider>
      <AuthModalContextProvider>
        <CurrencyProvider>
          <TrackingScript />
          <NoiseBackground />
          {group && <GroupTopBarBanner group={group} />}
          <NewFlexContainer
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            css={css`
              max-width: 1440px;
              padding: 16px 24px;
              margin: 0 auto;
              background-color: ${unifiedColors.surface.secondary};
              ${themeUtils.maxWidth.md} {
                padding: 8px 0;
              }
            `}
          >
            <SearchBarProvider>
              <Header allCurrencies={allCurrencies} rounded={rounded} />
              <div style={{ position: 'relative', width: '100%' }}>
                {children}
              </div>
            </SearchBarProvider>
          </NewFlexContainer>
          <Footer />
        </CurrencyProvider>
      </AuthModalContextProvider>
    </UserActionsProvider>
  )
}
